// Auto-generated normalizer for table: EstudiantesCurso
export function estudiantesCursoNormalize(row) {
  return {
    idEstudiantesCursos: row.idEstudiantesCursos ?? row.IdEstudiantesCursos ?? row['IdEstudiantesCursos'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    calificacionFinal: row.calificacionFinal ?? row.CalificacionFinal ?? row['CalificacionFinal'] ?? 0,
    idEstado: row.idEstado ?? row.IdEstado ?? row['IdEstado'] ?? 0,
    certificadoGenerado: row.certificadoGenerado ?? row.CertificadoGenerado ?? row['CertificadoGenerado'] ?? false,
    ultimoAcceso: row.ultimoAcceso ?? row.UltimoAcceso ?? row['UltimoAcceso'] ?? null,
    fechaTermino: row.fechaTermino ?? row.FechaTermino ?? row.fechTermino ?? row.FechTermino ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
